import React, { useState } from "react";
import { GoogleMap, useLoadScript, MarkerF } from "@react-google-maps/api";
import { config } from "../../config";
import StayCard from "./StayCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

function Map({ stays = [], isOpen, onClose }) {
  const [selectedStay, setSelectedStay] = useState(null);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: config.googleMapsApiKey,
  });

  const defaultCenter = {
    lat: 51.5074,
    lng: -0.1278,
  };

  const center = stays?.[0]?.accommodation?.location?.geographic_coordinates
    ? {
        lat: stays[0].accommodation.location.geographic_coordinates.latitude,
        lng: stays[0].accommodation.location.geographic_coordinates.longitude,
      }
    : defaultCenter;

  // Create a custom marker label component
  const createPriceMarker = (price) => {
    return {
      text: `$${Math.round(parseFloat(price))}`,
      className:
        "bg-white px-2 py-1 rounded-full shadow-lg text-sm font-semibold",
      color: "#000000",
    };
  };

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading map...</div>;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 z-50 ${
        isOpen ? "" : "hidden"
      }`}
    >
      <div className="h-full p-4">
        <div className="relative h-full">
          <button
            onClick={onClose}
            className="absolute right-4 top-4 z-10 bg-white p-2 rounded-full shadow-lg"
          >
            <FontAwesomeIcon icon={faTimes} className="text-gray-600" />
          </button>

          <GoogleMap
            mapContainerStyle={{
              width: "100%",
              height: "100%",
              borderRadius: "0.5rem",
            }}
            zoom={13}
            center={center}
            options={{
              fullscreenControl: false,
              streetViewControl: false,
            }}
          >
            {stays?.map((stay) => {
              const coords =
                stay?.accommodation?.location?.geographic_coordinates;
              if (!coords?.latitude || !coords?.longitude) return null;

              return (
                <MarkerF
                  key={stay.id || stay.accommodation.id}
                  position={{
                    lat: coords.latitude,
                    lng: coords.longitude,
                  }}
                  onClick={() => setSelectedStay(stay)}
                  icon={null} // Remove default pin icon
                  label={createPriceMarker(stay.cheapest_rate_total_amount)}
                />
              );
            })}
          </GoogleMap>

          {selectedStay && (
            <div
              key={selectedStay.id || selectedStay.accommodation.id}
              className="absolute bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-[900px]"
            >
              <div className="relative w-full">
                <button
                  onClick={() => setSelectedStay(null)}
                  className="absolute right-2 top-2 z-10 bg-white p-2 rounded-full hover:bg-gray-100"
                >
                  <FontAwesomeIcon icon={faTimes} className="text-gray-600" />
                </button>
                <StayCard stay={selectedStay} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Map;
